import { render, staticRenderFns } from "./checkStarLevel.vue?vue&type=template&id=3f947111&scoped=true"
import script from "./checkStarLevel.vue?vue&type=script&lang=js"
export * from "./checkStarLevel.vue?vue&type=script&lang=js"
import style0 from "./checkStarLevel.vue?vue&type=style&index=0&id=3f947111&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f947111",
  null
  
)

export default component.exports